import { HandoffCredentialsAction } from '../models/handoffSession';
import { ProductDimension } from '../models/product';

export type BuildTppToWebUrl = {
  origin: string;
  clientName: string;
};

export type BuildShortHandoffUrlForMobile = {
  origin: string;
  version: string;
  handoffSessionId: string;
};

type BuildHandoffUrlToMinimize = {
  version: string;
  productType: string;
  productDimension: ProductDimension;
  handoffCredentialsAction: HandoffCredentialsAction;
  authorizationToken: string;
  trackingId: string;
  market: string;
  path?: string;
  location?: Location;
};

type RouteBuilder = {
  buildTppToWebUrl: { build: (props: BuildTppToWebUrl) => string; path: string };
  buildShortHandoffUrlForMobile: {
    build: (props: BuildShortHandoffUrlForMobile) => string;
    path: string;
  };
  buildHandoffUrlToMinimize: {
    build: (props: BuildHandoffUrlToMinimize) => string;
    path: string;
  };
};

export const routeBuilder: RouteBuilder = {
  buildTppToWebUrl: {
    build: ({ origin, clientName }: BuildTppToWebUrl) => {
      return `${origin}/result/tpp-to-web/${clientName}`;
    },
    path: '/result/tpp-to-web/:clientName',
  },
  buildShortHandoffUrlForMobile: {
    build: ({ origin, version, handoffSessionId }: BuildShortHandoffUrlForMobile) => {
      return `${origin}/${version}/handoff/${handoffSessionId}`;
    },
    path: `:origin/:version/handoff/:handoffSessionId`,
  },
  buildHandoffUrlToMinimize: {
    build: ({
      version,
      productType,
      productDimension,
      handoffCredentialsAction,
      authorizationToken,
      trackingId,
      market,
      path = '/handoff-mobile-device',
      location = window.location,
    }: BuildHandoffUrlToMinimize) => {
      // In the future we might want to use applicationParameters instead so that we are using validated parameters
      const { search } = location;
      const newSearchQuery = new URLSearchParams(search);
      // We want user to be logged in by consuming handoff session not by `authorization_code`.
      newSearchQuery.delete('authorization_code'); // should use auth token
      newSearchQuery.delete('tracking_id');
      newSearchQuery.delete('authorization_token');
      newSearchQuery.append('tracking_id', trackingId);
      newSearchQuery.append('authorization_token', authorizationToken);
      newSearchQuery.append('market', market);

      return `/${version}/${productType}/${productDimension}${path}/${handoffCredentialsAction}?${newSearchQuery}`;
    },
    path: '/:version/:productType/:productDimension/handoff-mobile-device/:credentialsAction',
  },
};
